import { styled } from '@mui/system';
import { Box, Typography, IconButton, Button } from '@mui/material';

// LIVE CHAT STYLES

export const LiveChatMainBox = styled(Box)(({ }) => ({
    display: 'block',
    position: 'absolute',
    bottom: 'calc(100% + 10px)',
    right: '0',
    width: 420,
    backgroundColor: '#002F73',
    borderRadius: 10,
    boxShadow: '0px 4px 34px 0px rgba(0, 0, 0, 0.14)',
}));

export const LiveChatHeader = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'flex-start',
    padding: theme.spacing(3, 2, 2, 2),
    background: 'url(/images/live-chat-bg.png) no-repeat top center',
    backgroundSize: 'cover',
    borderRadius: '10px 10px 0 0',
}));

export const LiveChatHeaderIcon = styled(Box)(({ }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fff',
    borderRadius: 100,
    width: 62,
    height: 62,
}));

export const WelcomeTxtBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexFlow: 'column',
    marginTop: theme.spacing(2.5),
}));

export const HelloTxt = styled(Typography)(({ }) => ({
    display: 'block',
    color: '#fff',
    fontSize: 18,
    fontWeight: 600,
}));

export const WelcomeTxt = styled(Typography)(({ }) => ({
    display: 'flex',
    color: '#fff',
    fontSize: 28,
    fontWeight: 600,
    gap: 8,
    '& span': {
        display: 'inline-flex',
        alignItems: 'center',
        color: '#27F13B',
        gap: 10,
        '& .circle': {
            display: 'block',
            width: 12,
            height: 12,
            backgroundColor: '#27F13B',
            borderRadius: 100,
        }
    }
}));

export const LiveChatBody = styled(Box)(({ theme }) => ({
    display: 'block',
    backgroundColor: '#F6F6F6',
    borderRadius: 10,
    padding: theme.spacing(3, 2),
    '&:not(:last-child)': {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
    }
}));

export const LiveChatOption = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#fff',
    borderRadius: 10,
    padding: theme.spacing(2.5),
    boxShadow: '0px 1px 10px 0px rgba(0, 0, 0, 0.06)',
    cursor: 'pointer',
    transition: '500ms',
    '&:not(:first-of-type)': {
        marginTop: theme.spacing(1.5),
    },
    '&:hover': {
        backgroundColor: '#d0e0ff',
    }
}));

export const LiveChatOptionAvatar = styled(Box)(({ }) => ({
    display: 'block',
    position: 'relative',
}));

export const LiveChatOptionStatus = styled(Box)(({ }) => ({
    display: 'block',
    position: 'absolute',
    top: 3,
    right: 0,
    width: 10,
    height: 10,
    backgroundColor: '#27F13B',
    border: '1.5px solid #fff',
    borderRadius: 100,
}));

export const LiveChatOptionMid = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'flex-start',
    padding: theme.spacing(0, 2),
    flex: 1,
}));

export const LiveChatOptionTl = styled(Typography)(({ }) => ({
    display: 'block',
    color: '#202935',
    fontSize: 20,
    fontWeight: 600,
}));

export const LiveChatOptionDesc = styled(Typography)(({ theme }) => ({
    display: 'block',
    color: '#4E4E4E',
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 400,
    marginTop: theme.spacing(0.5),
}));

export const LiveChatOptionArrow = styled(Box)(({ }) => ({
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
}));

export const LiveChatUser = styled(Box)(({ }) => ({
    display: 'flex',
    alignItems: 'center',
}));

export const LiveChatUserPhoto = styled(Box)(({ }) => ({
    display: 'inline-flex',
    position: 'relative',
}));

export const LiveChatUserName = styled(Box)(({ }) => ({
    display: 'inline-flex',
    position: 'relative',
    color: '#fff',
    fontSize: 18,
    fontWeight: 600,
    paddingLeft: 12,
}));

export const LiveChatTime = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    color: '#ADB2B5',
    fontSize: 12,
    lineHeight: '14px',
    fontWeight: 500,
    '& .time': {
        marginLeft: 'auto',
        marginTop: theme.spacing(0.75),
    },
    '& .day': {
        color: '#7B7B7B',
        backgroundColor: '#fff',
        border: '1px solid #DADADA',
        borderRadius: '100px',
        padding: theme.spacing(0.25, 1),
        marginBottom: theme.spacing(2),
    }
}));

export const LiveChatMessageContainer = styled(Box)(({ }) => ({
    display: 'flex',
    flexFlow: 'column',
    maxHeight: 300,
    overflow: 'auto',
}));

export const LiveChatMessageBox = styled(Box)(({ theme }) => ({
    display: 'inline-flex',
    flexFlow: 'column',
    width: 'auto',
    maxWidth: '70%',
    marginBottom: theme.spacing(1.5),
    '&.me': {
        alignSelf: 'flex-end',
        paddingRight: theme.spacing(5),
        position: 'relative',
        maxWidth: 'calc(70% + 30px)',
        '& .MuiAvatar-circular': {
            position: 'absolute',
            bottom: 18,
            right: 0,
        },
        '& .liveChatMessage': {
            backgroundColor: '#002F73',
            color: '#fff',
            borderRadius: '12px 12px 0 12px',
        }
    }
}));

export const LiveChatMessage = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#fff',
    padding: theme.spacing(1.5, 2),
    boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.05)',
    borderRadius: '12px 12px 12px 0',
    color: '#171717',
    fontSize: 14,
    lineHeight: '20px',
    minHeight: '42px',
}));

export const LiveChatFooter = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    width: '100%',
    backgroundColor: '#fff',
    borderRadius: '0 0 10px 10px',
    padding: theme.spacing(1, 2),
    '& .MuiInputBase-root': {
        borderRadius: '100px !important',
        margin: '0 !important',
        '& .MuiInputBase-input': {
            borderRadius: 100,
            minHeight: '46px !important',
            backgroundColor: '#fff',
            paddingLeft: '48px !important',
        },
        '& fieldset': {
            borderRadius: 100,
            paddingLeft: theme.spacing(6),
        }
    }
}));

export const SendButton = styled(IconButton)(({ }) => ({
    width: 46,
    height: 46,
    backgroundColor: '#00B5FF',
    '&:hover': {
        backgroundColor: '#04a3e4',
    },
    '& img': {
        width: 20,
        height: 'auto',
        filter: 'brightness(0) invert(1)',
    },
}));

export const LiveChatTypeArea = styled(Box)(({ }) => ({
    display: 'block',
    position: 'relative',
    flex: 1,
}));

export const AttachButton = styled(IconButton)(({ }) => ({
    width: 38,
    height: 38,
    background: 'transparent',
    position: 'absolute',
    top: 4,
    left: 5,
    zIndex: 1,
    '&:hover': {
        backgroundColor: '#f2f2f2',
    },
    '& img': {
        width: 20,
        height: 'auto',
    },
}));

// CHATBOT INTERFACE STYLES

export const ChatBotBox = styled(Box)(({ }) => ({
    width: 420,
    height: 500,
    maxHeight: '100%',
    backgroundColor: '#ecf0f4',
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    border: '1px solid #d8dbdd',
}));

export const ChatBotHeader = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    padding: theme.spacing(1.5, 1.5),
    backgroundColor: '#fff',
}));

export const ChatCompanyLogo = styled(Box)(({ theme }) => ({
    display: 'inline-flex',
    height: '36px',
    width: '36px',
    backgroundColor: '#fff',
    borderRadius: '100px',
    overflow: 'hidden',
    border: '1px solid #c9cdd0',
    '&.userImage': {
        height: '36px',
        width: '36px',
        flex: '0 0 36px',
        marginRight: theme.spacing(1),
    },
    '& img': {
        display: 'block',
        float: 'left',
        height: '100%',
        width: '100%',
        objectFit: 'cover',
        objectPosition: 'top center',
    },
}));

export const ChatCompanyName = styled(Typography)(({ theme }) => ({
    display: 'inline-flex',
    paddingLeft: theme.spacing(1.25),
    overflow: 'hidden',
    color: theme.palette.primary.main,
    fontSize: '17px',
    fontWeight: '600',
}));

export const ChatBotBody = styled(Box)(({ theme }) => ({
    display: 'flex',
    flex: 1,
    padding: theme.spacing(1.5),
    overflowY: 'auto',
    flexDirection: 'column',
    fontSize: '0.875rem',
}));

export const ChatMsgListing = styled(Box)(({ }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '16px',
}));

export const ChatMssList = styled(Box)(({ theme }) => ({
    display: 'inline-flex',
    alignItems: 'flex-start',
    maxWidth: '100%',
    position: 'relative',
    paddingLeft: theme.spacing(5.25),
    '& .userImage': {
        position: 'absolute',
        top: 0,
        left: 0,
        margin: 0,
        justifyContent: 'center',
        alignItems: 'center',
    },
    '&.user': {
        alignSelf: 'flex-end',
        flexFlow: 'column',
        alignItems: 'flex-end',
        paddingRight: theme.spacing(5.25),
        paddingLeft: 0,
        '& .userImage': {
            left: 'auto',
            right: 0,
            '& img': {
                width: 'auto',
                maxWidth: 30,
                height: 'auto',
                opacity: 0.7,
            },
        },
        '& > .MuiBox-root:first-of-type': {
            marginRight: 0,
            marginLeft: theme.spacing(1),
        },
        '& > .MuiBox-root:nth-of-type(2)': {
            minWidth: '1px',
            borderRadius: '10px 0 10px 10px',
            color: '#fff',
            backgroundColor: '#3062d0',
        }
    },
}));

export const ChatMssListBox = styled(Box)(({ }) => ({
    display: 'inline-flex',
    flexDirection: 'column',
    backgroundColor: '#fff',
    borderRadius: '0 10px 10px 10px',
    boxShadow: '0 1px 3px 0px rgba(1,28,70,0.2)',
    '&:not(.user)': {
        minWidth: '160px',
    },
    '&.user': {
        alignSelf: 'flex-end',
        borderRadius: '10px 0 10px 10px',
        color: '#fff',
        backgroundColor: '#3062d0',
    },
}));

export const ChatTypingIndicator = styled(Box)(() => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 5,
    minHeight: 46,
    padding: '12px 16px',
    '& span': {
        width: 7,
        height: 7,
        borderRadius: '50%',
        backgroundColor: '#718096',
        animation: 'chatTypingBounce 1.2s ease-in-out infinite',
    },
    '& span:nth-of-type(2)': {
        animationDelay: '0.15s',
    },
    '& span:nth-of-type(3)': {
        animationDelay: '0.3s',
    },
    '@keyframes chatTypingBounce': {
        '0%, 60%, 100%': {
            opacity: 0.45,
            transform: 'translateY(0)',
        },
        '30%': {
            opacity: 1,
            transform: 'translateY(-4px)',
        },
    },
}));

export const ChatMsg = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: theme.spacing(1.75, 1.25),
    fontSize: '14px',
    lineHeight: '18px',
    fontWeight: '500',
}));

export const ChatMsgOptions = styled(Button)(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(1, 1.25),
    fontSize: '14px',
    lineHeight: '18px',
    minHeight: '38px',
    fontWeight: '500',
    color: '#3062d0',
    borderTop: '1px solid #ddd',
    '&:last-child': {
        borderRadius: '0 0 10px 10px',
    }
}));

export const ChatBotFooter = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    padding: theme.spacing(0),
    backgroundColor: '#ecf0f4',
    position: 'relative',
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    borderTop: '1px solid #c1c4c8',
    '& form': {
        display: 'flex',
        width: '100%',
        alignItems: 'stretch',
        gap: 1,
        '& > .MuiIconButton-root': {
            backgroundColor: '#3062d0',
            width: 54,
            height: 54,
            borderRadius: 100,
            alignSelf: 'center',
            marginLeft: theme.spacing(1),
            '& img': {
                width: 20,
                filter: 'brightness(0) invert(1)',
            },
        },
    },
    '& .MuiInputBase-root': {
        margin: '0 !important',
        background: 'transparent !important',
        borderRadius: '0px !important',
        border: 'none',
        '& .MuiInputBase-input': {
            backgroundColor: '#fff',
            borderRadius: 10,
            padding: theme.spacing(1.5, 2.5, 1.5, 2),
        },
        '& fieldset': {
            border: 'none !important',
        }
    },
    '&.agentChatComposer': {
        '& form': {
            alignItems: 'flex-end',
        },
        '& .chatTextArea': {
            flex: 1,
            minWidth: 0,
        },
        '& .MuiInputBase-root': {
            alignItems: 'flex-end',
            backgroundColor: '#fff !important',
            borderRadius: '10px !important',
            transition: 'box-shadow 160ms ease',
            '&:focus-within': {
                boxShadow: '0 0 0 2px rgba(48, 98, 208, 0.16)',
            },
            '& textarea.MuiInputBase-input': {
                lineHeight: '20px',
                maxHeight: 100,
                overflowY: 'auto !important',
                resize: 'none',
            },
        },
        '& form > .MuiIconButton-root': {
            alignSelf: 'flex-end',
            flexShrink: 0,
        },
    },
}));

export const ChatFooterOptions = styled(Box)(({ theme }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    position: 'relative',
    marginLeft: theme.spacing(1),
    '& .MuiIconButton-root': {
        position: 'static',
    },
}));

export const ChatAttachments = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    margin: theme.spacing(-0.4),
}));

export const ChatAttachmentCol = styled(Box)(({ theme }) => ({
    display: 'flex',
    float: 'left',
    justifyContent: 'center',
    alignItems: 'center',
    width: 48,
    height: 48,
    margin: theme.spacing(0.4),
    backgroundColor: '#fff',
    border: '1px solid #485052',
    borderRadius: 8,
    cursor: 'pointer',
    position: 'relative',
    '&:before': {
        content: '""',
        display: 'block',
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0,0,0,0.5)',
        position: 'absolute',
        top: 0,
        left: 0,
        transition: '500ms',
        opacity: '0',
        visibility: 'hidden',
    },
    '&:not(.counterOnly):hover:before': {
        opacity: '1',
        visibility: 'visible',
    },
    '&.counterOnly': {
        cursor: 'default',
        fontWeight: 600,
    },
    '& img': {
        display: 'block',
        width: 'auto',
        maxWidth: '100%',
        height: 'auto',
        maxHeight: '100%',
        '&.icon': {
            maxWidth: '32px',
            maxHeight: '32px',
        }
    },
    '& .close': {
        padding: 0,
        margin: 0,
        backgroundColor: '#505050',
        minWidth: '1px !important',
        minHeight: '1px !important',
        width: '16px',
        height: '16px',
        borderRadius: 100,
        position: 'absolute',
        top: '-6px',
        right: '-6px',
        '&:hover': {
            backgroundColor: '#ff0e0e',
        },
        '& img': {
            filter: 'brightness(0) invert(1)',
            width: '12px',
            height: 'auto',
        },
    },
}));
